let colors = ["#FF571F",
  "#1B909D",
  "#084C61",
  "#323031",
  "#323031",
  "#323031",
  "#323031"
]

export default colors;
